export enum TableViewTypes {
  GET_TABLE_VIEWLIST = '@@views/GET_TABLE_VIEWLIST',
  GET_TABLE_VIEWLIST_SUCCESS = '@@views/GET_TABLE_VIEWLIST_SUCCESS',
  GET_TABLE_VIEWLIST_FAIL = '@@views/GET_TABLE_VIEWLIST_FAIL',

  CREATE_TABLE_VIEW = '@@views/CREATE_TABLE_VIEW',
  CREATE_TABLE_VIEW_SUCCESS = '@@views/CREATE_TABLE_VIEW_SUCCESS',
  CREATE_TABLE_VIEW_FAIL = '@@views/CREATE_TABLE_VIEW_FAIL',

  UPDATE_TABLE_VIEW = '@@views/UPDATE_TABLE_VIEW',
  UPDATE_TABLE_VIEW_SUCCESS = '@@views/UPDATE_TABLE_VIEW_SUCCESS',
  UPDATE_TABLE_VIEW_FAIL = '@@views/UPDATE_TABLE_VIEW_FAIL',

  DELETE_TABLE_VIEW = '@@views/DELETE_TABLE_VIEW',
  DELETE_TABLE_VIEW_SUCCESS = '@@views/DELETE_TABLE_VIEW_SUCCESS',
  DELETE_TABLE_VIEW_FAIL = '@@views/DELETE_TABLE_VIEW_FAIL',
}
